export function expectDefined<T>(it: T | null | undefined): T {
	if (it == null) {
		throw new Error(`[t8b59w] Expected defined, got: ${it}`)
	}
	return it
}
